import React, { useState } from 'react';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Badge from '@material-ui/core/Badge';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import withStyles from '@material-ui/core/styles/withStyles';
import { signOutUser } from 'global/GlobalActions';
import { useSelector } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import { Typography } from '@material-ui/core';

const StyledBadge = withStyles(theme => ({
  badge: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.main,
    boxShadow: '0 0 0 2px #fff',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

export default function HeaderUserbox() {
  const { user } = useSelector(state => state.User);
  const profilePic = get(user, 'profile_pic', null);
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const gotoSettings = () => {
    setAnchorEl(null);
    history.push('/settings');
  };

  return (
    <Box marginRight="8px">
      <Button color="inherit" onClick={handleClick} style={{ textAlign: 'left', padding: '5px' }}>
        <Box>
          <StyledBadge overlap="circle" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
            <Avatar sizes="44" alt="-" src={profilePic} />
          </StyledBadge>
        </Box>
        <Hidden lgDown>
          <Box paddingX={1}>
            <Typography style={{ fontWeight: 'bold' }}>{get(user, 'name', '')}</Typography>
            <Typography style={{ color: '#ffffff80' }}>{get(user, 'email', '')}</Typography>
          </Box>
        </Hidden>
        <ExpandMoreIcon fontSize="small" />
      </Button>

      {Boolean(anchorEl) ? (
        <Menu
          anchorEl={anchorEl}
          keepMounted
          getContentAnchorEl={null}
          open={true}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          onClose={handleClose}>
          <List style={{ minWidth: '15rem', textAlign: 'center' }}>
            <Box>
              <StyledBadge overlap="circle" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
                <Avatar sizes="44" alt="-" src={profilePic} />
              </StyledBadge>
            </Box>
            <Box>
              <Typography style={{ fontWeight: 'bold' }}>{get(user, 'name', '')}</Typography>
              <Typography color="textSecondary">{get(user, 'email', '')}</Typography>
            </Box>
            <Divider style={{ marginTop: '0.5rem' }} />
            <ListItem button color="secondary" onClick={gotoSettings}>
              Settings
            </ListItem>
            <ListItem button color="secondary" onClick={() => signOutUser('/PagesRegister')}>
              Sign Out
            </ListItem>
          </List>
        </Menu>
      ) : null}
    </Box>
  );
}
